<template>
	<div>
		<span v-if="displayedValues.length === 0">N/A</span>
		<span v-for="tag in displayedValues" :key="`field-${ field.id }-${ tag.id }`" class="tag">{{ tag.name }}</span>
		<span v-if="hasTruncated" class="tag">+{{(values || []).length - 2 }} More</span>
	</div>
</template>

<script>

import StatusFields from '@/mixins/StatusFields';

export default {

	props: [ 'row', 'field' ],

	mixins: [StatusFields],

	data() {
		return {
			inputVal: (this.value || []).map(tag => tag.id),
			settings: {
				valueField: 'id',
				labelField: 'name',
				searchField: [ 'name' ],
				persist: false,
				create: function(input) {
					return {
						id: input,
						name: input,
					};
				},
			},
		};
	},

	computed: {
		values() {
			return this.row[ this.field.slug ];
		},
	},
};
</script>
